import * as config from "./data-table-config";
import { CONFIGURATION_MODULE } from "./data-table-config/configuration/configuration-module.config";
import { REPORT_MODULE } from "./data-table-config/report/report-module.config";
import {OPERATION_MODULE} from './data-table-config/operation/operation-module.config';
export const SCHEMAS = {
  ...CONFIGURATION_MODULE,
  ...REPORT_MODULE,
  ...OPERATION_MODULE,
  inStorePicking: config.inStorePicking,
  inStorePickingDetail: config.inStorePickingDetail,
  inStoreLocation: config.inStoreLocation,
  saleNote: config.saleNotes,
  saleNoteDetail: config.saleNoteDetail,
  updatePrices: config.updatePrices,
  confirmationDispatches: config.confirmationDispatches,
  carrier: config.carrier,
  dispatchToCustomer: config.dispatchToCustomer,
  dispatchToCustomerDetail: config.dispatchToCustomerDetail,
  detailDispatchTrip: config.detailDispatchTrip,
  trip: config.trip,
  reazonRejection: config.reazonRejection,
  detailTrip: config.detailTrip,
  picking: config.picking,
  consolidatedPicking: config.consolidatedPicking,
  consolidatedPickingDetail: config.consolidatedPickingDetail,
  consolidatedPickingDetailExtern: config.consolidatedPickingDetailExtern,
  reportPickingReadMore: config.reportPickingReadMore,
  dispatchesCanceled: config.dispatchCanceled,
  guidePrint: config.guidePrint,
  travelCode: config.reasonGuidePrint,
  dispatchesCanceledState: config.dispatchesCanceledState,
  dispatchCode: config.reasonGuidePrintDispatch,
  userSetting: config.userSetting,
  searchQuotationInfo: config.searchQuotationInfo,
  approveQuotation: config.approveQuotation,
  associatedQuotes: config.associatedQuotes,
  cancellationMultiple: config.cancellationMultiple,
  servicesAdditional: config.servicesAdditional,
  detailDispatchWithdraw: config.detailDispatchWithdraw,
  cancellationTicket: config.cancellationTicket,

  approvePending: config.approvePending,
  partialCancellation: config.partialCancellation,
  inStoreListDeliver: config.inStoreListDeliver,
  dispatchProductPreCancellation: config.dispatchProductPreCancellation,
  pickingCancel: config.pickingCancel,
  dispatchesNotLoaded: config.dispatchesNotLoaded,
  dispatchesToLoad: config.dispatchesToLoad,
  dispatchesToLoadTrip: config.dispatchesToLoadTrip,
  tripsMassive: config.tripsMassive,
  tripImport: config.tripImport,
  detailTripDeliver: config.DetailTripDeliver,
  tripDeliver: config.TripDeliver,
  confirmationImport: config.confirmationImport,
  formatSkuInCustomerDispatch: config.formatSkuInCustomerDispatch,
  formatDispatchInCustomerDispatch: config.formatDispatchInCustomerDispatch,
  dispatchNotProcessed: config. dispatchNotProcessed,
  pickingReport: config.pickingReport,
  orderDeliveryTurbo: config.OrderDeliveryTurbo,
  dispatchTripBeetrack: config.DispatchTripBeetrack,
  exceptionsInOrderAssignment: config.exceptionsInOrderAssignment,
  pickingAudit: config.pickingAudit,
  pickingAuditDetail: config.pickingAuditDetail,
  auditProduct: config.auditProduct,
  relocateProductsInAudit: config.relocateProductsInAudit,
  dispatchesToCreateLots: config.dispatchesToCreateLots,
  detailOfDispatchesToCreateLots: config.detailOfDispatchesToCreateLots,
  selectedDispatchesForNewLot: config.selectedDispatchesForNewLot,
  lotsList: config.lotsList,
  transitCompliance   : config.transitCompliance,
  deliveryDate        : config.deliveryDate,
  closedDispatch      : config.closedDispatch,
  deliveryConfirmation: config.deliveryConfirmation,
  pickingDateVsSaleDate : config.pickingDateVsSaleDate,
  pickupDateByClient: config.pickupDateByClient,
  dispatchTrips: config.dispatchTrips,
  dispatchProductReturned : config.dispatchProductReturned,
  reportDiscount: REPORT_MODULE.reportDiscount,
  userExternalSetting: config.userExternalSetting,
  consolidatedPickingExternal: config.consolidatedPickingExternal,
  supportTickets: config.supportTickets,
};
